import CheerzApiUser, { CheerzApiUserChecked } from "@Types/api/user";
import User, { UserChecked } from "@Types/user";

export function convertFromApiToUserContent(jsonContent: CheerzApiUser): User {
  return {
    currency: jsonContent.currency,
    email: jsonContent.email ? jsonContent.email : undefined,
    firstName: jsonContent.firstname,
    isGuest: jsonContent.guest,
    md5Email: jsonContent.email_md5,
    userId: jsonContent.user_id,
  };
}

export const convertUserCheckedFromApiToContent = (
  jsonContent: CheerzApiUserChecked,
  token?: string
): UserChecked => {
  return {
    email: jsonContent.email,
    isExisting: jsonContent.user_exists,
    token,
  };
};
